import React from 'react'
import logo from "../src/assets/Seket.png"
import hero from "../src/assets/hero.png"
import features from "../src/assets/features.png"
import plane from "../src/assets/jet.png"
import palette from "../src/assets/Color Palette.png"
import code from "../src/assets/Coding Folder.png"
import dart from "../src/assets/3dicons.png"
import hat from "../src/assets/Graduation Hat.png"
import clock from "../src/assets/clock.png"
import tick from "../src/assets/octicon_check-16.png"
import linkedin from "../src/assets/ri_linkedin-fill.png"
import facebook from "../src/assets/ri_facebook-fill.png"
import twitter from "../src/assets/ri_twitter-fill.png"
import instagram from "../src/assets/ri_instagram-line.png"
import telegram from "../src/assets/basil_telegram-outline.png"
import { HashLink as Link } from 'react-router-hash-link';





const Desktop = () => {
  return (
    <div className="font-poppins">
    <header className=' bg-gradient-to-b from-amber-100 to-white h-screen px-44 py-7    ' > 
        <nav className = "flex items-center justify-between  ">
         <img src= {logo} alt="logo" className='w-24'></img>
         <ul className='flex gap-10 ' >
            <li className="hover:border-b-4 border-[#998537]"> <Link to="#features">Features</Link></li>
            <li className='hover:border-b-4 border-[#998537]'> <Link to="#categories">Categories</Link></li>
            <li className='hover:border-b-4 border-[#998537]'> <Link to="#pricing">Pricing</Link></li>
         </ul>
         <div className='flex gap-10'>
            <button>English</button>
            <button className='bg-black text-white p-3 rounded-md'   >Sign Up</button>
         </div>
        </nav>
   
        
    <section  className='flex mt-32 items-start justify-between' >
        <div >
            <h1 className='text-6xl font-bold leading-smug mb-5'>
                IGNITE YOUR <span className='text-[#998537] '>POTENTIAL</span>
            </h1>
            <p className='text-xl mb-5'>
                Perfect solution for practicing, taking and giving online exam
            </p>
            <div className='flex  gap-5 text-sm mb-10'>
                <p className='border-b-2  border-[#998537]'>Take a quick tour</p>
                <p className='border-b-2 border-[#998537]'>Discover all the features</p>
            </div>
            <button className= ' flex items-center justify-center bg-black text-l text-white px-10 py-2 rounded-lg'>Practice Demo</button>
        </div>

        <div>
          <img src={hero} alt="hero"></img>
        </div>

    </section>
    
    </header>



    <section id="features" className='flex justify-between  relative space-x-24 items-start px-44 py-7 '>
    <div>
        <img className ="w-[400px]"src={features} alt="features"></img>
    </div>
     <div className='flex flex-col items-start w-1/2'>
        <h2 className='text-4xl border-b-4 mb-10 border-[#998537]'>Features</h2>
        <p className='text-[20px] mb-8  leading-relaxed'  > Join thousands of students and educators who have already 
            experienced the benefits of our exam system. 
            Get started today and unlock your full academic potential!</p>
        <p className='text-[20px] mb-8  leading-relaxed'>
        Join thousands of students and educators who have already experienced the 
        benefits of our exam system. Get started today and unlock your full academic potential!
        </p>
        <button className='border-[3px] font-bold text-[#998537] px-4 py-2 border-[#998537] '>Explore More</button>
     </div>
    </section>

    <section className='flex justify-between items-start bg-gradient-to-r from-white to-[#A79E8C] h-[200px] mt-14 mb-14'>
        <div className='pl-44 py-7 w-1/2'>
            <p>What we do</p>
            <h2 className='text-4xl font-bold mt-3'><span className='text-[#998537]'>Perfect Solution</span> For Your Business and Career</h2>
        </div>
        <div>
            <img className="pr-30 py-7 w-[80%]"   src ={plane} alt="plane"></img>
        </div>
    </section>

    <section id="categories" className='mb-32 pl-32 pr-28  py-7 mt-32'>
        <div className='flex mb-12 items-center justify-between'>
            <h2 className='text-4xl border-b-4 border-[#998537]'>Catagories</h2>
            <button className='text-[#998537] text-xl border-b-2 border-[#998537]'>Explore More</button>
        </div>

        <div className='flex items-center justify-between text-white  gap-10'>
            <div className=' flex w-1/4 flex-col items-center  space-y-12 justify-center bg-gradient-to-b from-[#EA5455] to-[#E58989] rounded-md px-12 py-8 '>
                <h4 className='font-semibold'>ART & DESIGN</h4>
                <img className='w-[120px]'   src ={palette} alt="palette"></img>
                <button className='bg-white text-black shadow-2xl px-12 py-2 rounded-md '>EXPLORE</button>
            </div>

            <div className=' flex w-1/4 flex-col items-center space-y-12 justify-center bg-gradient-to-b from-[#FFC400] to-[#EDBD20] rounded-md px-12 py-8 '>
                <h4>IT & SOFTWARE</h4>
                <img className='w-[120px]'  src ={code} alt="palette"></img>
                <button className='bg-white text-black shadow-2xl px-12 py-2 rounded-md '>EXPLORE</button>
            </div>

            <div className=' flex w-1/4 flex-col items-center space-y-12 justify-center bg-gradient-to-b from-[#6AD098] to-[#9AEABE] rounded-md px-12 py-8 '>
                <h4>IT & SOFTWARE</h4>
                <img className='w-[120px]'  src ={dart} alt="palette"></img>
                <button className='bg-white text-black shadow-2xl px-12 py-2 rounded-md '>EXPLORE</button>
            </div>

            <div className=' flex w-1/4 flex-col items-center space-y-12 justify-center bg-gradient-to-b from-[#1E90FF] to-[#89C3FB] rounded-md px-12 py-8 '>
                <h4>ACADEMICS</h4>
                <img className='w-[120px]'  src ={hat} alt="palette"></img>
                <button className='bg-white text-black shadow-2xl px-12 py-2 rounded-md '>EXPLORE</button>
            </div>
        </div>

   </section>

  <section className='flex justify-between items-center px-44 py-7 bg-gradient-to-r mb-32 from-white to-[#A79E8C] h-[200px] mt-14'>
        <div>
            <img  className="pr-30 py-7 w-[80%]" src ={clock} alt="plane"></img>
        </div>
        <div className='py-7 w-1/2'>
            <p className='font-bold'>Track Progress</p>
            <h2 className='text-4xl font-bold mt-3'>Effectively<span className='text-[#998537]'> Practice</span>, Monitor Your <span className='text-[#998537]'>Performance.</span></h2>
        </div>
       
    </section>

<section id= "pricing" className="flex items-start justify-between  gap-10 px-44 py-7 mt-28">
    <div className='space-y-9'>
        <h3 className='text-4xl'>Pricing</h3>
        <p className='text-2xl'>Pick a plan that suits you. Simple and transparent pricing.</p>
        <button className='border-4 px-10 py-4 border-[#998537] text-[#998537] '>Compare Price</button>
    </div>

    <div className='flex space-x-5'>
        <div className='bg-gradient-to-b from-[#4ECB71] to-[#CDFFDB] rounded-md flex flex-col items-center py-7 px-4 text-white w-[180px] shadow-xl'>
            <h4 className='font-bold text-xl mb-2'>Standard</h4>
            <p className='text-[10px] mb-4'>Get Started with basic features</p>
            <h2 className='font-bold text-4xl mb-3 '>99$</h2>

            <div className=' flex flex-col gap-2 mb-4'>
                <div className='flex'>
                    <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>All Basic Features</h5>
                </div>

                <div className='flex'>
                <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>3 Exams</h5>
                </div>

                <div className='flex'>
                <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>1 Exam Room</h5>
                </div>
            </div>
            <button className='bg-white text-black px-9 py-2'>Subscribe</button>
        </div>

        <div className='bg-gradient-to-b from-[#FA7C3A] to-[#FFC400] rounded-md flex-grow flex flex-col items-center py-7 px-4 text-white w-[210px] shadow-xl'>
            <h4 className='font-bold text-xl mb-2'>Standard</h4>
            <p className='text-[10px] mb-4'>Get Started with basic features</p>
            <h2 className='font-bold text-4xl mb-3 '>99$</h2>

            <div className=' flex flex-col gap-2 mb-4'>
                <div className='flex'>
                    <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>All Basic Features</h5>
                </div>

                <div className='flex'>
                <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>3 Exams</h5>
                </div>

                <div className='flex'>
                <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>1 Exam Room</h5>
                </div>
            </div>
            <button className='bg-white text-black px-9 py-2'>Subscribe</button>
        </div>


        <div className='bg-gradient-to-b from-[#0573FB] to-[#00C2CB] rounded-md flex flex-col items-center py-7 px-4 text-white w-[180px] shadow-xl'>
            <h4 className='font-bold text-xl mb-2'>Standard</h4>
            <p className='text-[10px] mb-4'>Get Started with basic features</p>
            <h2 className='font-bold text-4xl mb-3 '>99$</h2>

            <div className=' flex flex-col gap-2 mb-4'>
                <div className='flex'>
                    <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>All Basic Features</h5>
                </div>

                <div className='flex'>
                <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>3 Exams</h5>
                </div>

                <div className='flex'>
                <img className='h-fit' src ={tick} alt ="tick"></img>
                    <h5 className='text-[12px]'>1 Exam Room</h5>
                </div>
            </div>
            <button className='bg-white text-black px-9 py-2'>Subscribe</button>
        </div>

       



    </div>
</section>


<footer className='flex  flex-col  space-y-6 justify-between items-center py-5 bg-gradient-to-l from-white to-[#A79E8C] mt-14'>
    <img className='w-28' src={logo} alt="logo"></img>
    <div className='flex gap-10'>
        <img className='w-[30px] h-[30px]' src={linkedin} alt="icon"></img>
        <img className='w-[30px] h-[30px]' src={facebook} alt="icon"></img>
        <img className='w-[30px] h-[30px]' src={twitter} alt="icon"></img>
        <img  className='w-[30px] h-[30px]' src={instagram} alt="icon"></img>
        <img  className='w-[30px] h-[30px]'src={telegram} alt="icon"></img>
    </div>
    <ul className='flex gap-12'>
        <li>About</li>
        <li>Categories</li>
        <li>Features</li>
        <li>Contact</li>
    </ul>
    <div>
        <p>All rights reserved. Designed and made with 🧡 by Kuraz Technologies © 2023</p>
    </div>
</footer>


    </div>
  )
}

export default Desktop
